<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/request/details/', projectId, requestId]">Zurück zur Anfrage</a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/requests/overview']">Übersicht</a>
    </li>
  </ul>
</nav>

<main>
  <h2 class="mb1em">PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Request {{ projectId }}.0001.{{ requestId }} bearbeiten</h2>
  <app-request-form
    *ngIf="requests"
    [projectId]="projectId"
    [requestId]="requestId"
    [requestsData]="requests[0]"
    [isUpdateMode]="true">
  </app-request-form>
</main>
